import { deepMerge } from 'js/utils/Utils'
import Common from 'js/_core/Common'

const defaults = {
  instanceName: 'currentTimeDisplay',
  $names: {
    target: '[data-clock="current-time-display"] .mask_in',
    minuteHand: '[data-clock="minute"]',
    hourHand: '[data-clock="hour"]',
  },
}

export default class CurrentTimeDisplay {
  $contentRoot = document
  $target = null
  $minuteHand = null
  $hourHand = null

  lastMinute = -1

  constructor(options = {}) {
    deepMerge(this, defaults, options)
  }

  init() {
    this._set$()
    this._updateTime() // 初期表示
    this._addHandlers()
  }

  destroy() {
    this._removeHandlers()
  }

  _set$() {
    this.$target = this.$contentRoot.querySelector(this.$names.target)
    this.$minuteHand = this.$contentRoot.querySelector(this.$names.minuteHand)
    this.$hourHand = this.$contentRoot.querySelector(this.$names.hourHand)

    if (!this.$target) {
      console.warn('CurrentTimeDisplay: Target element not found.')
    }
  }

  _addHandlers() {
    if (Common.raf) {
      Common.raf.addHandler(() => this.onRaf(), this.instanceName)
    }
  }

  _removeHandlers() {
    Common.raf?.removeHandler(this.instanceName)
  }

  onRaf() {
    const now = new Date()
    const second = now.getSeconds()
    const minute = now.getMinutes()

    if (minute !== this.lastMinute) {
      this.lastMinute = minute
      this._updateTime(now)
    }

    // --- コロン点滅制御 ---
    this._toggleColon(second)
  }

  _updateTime(date = new Date()) {
    this._updateClockHands(date)

    const options = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
      timeZone: 'Asia/Tokyo',
      timeZoneName: 'short',
    }

    const formatted = new Intl.DateTimeFormat('en-US', options).format(date)
    if (this.$target) {
      // コロンをspanでラップしておく
      const html = formatted.replace(/:/g, '<span class="colon">:</span>')
      this.$target.innerHTML = html
    }
  }

  _updateClockHands(date) {
    const minute = date.getMinutes()
    const hour = date.getHours() % 12
    const minuteDeg = (minute / 60) * 360 + 90 // 90度ずらす
    const hourDeg = (hour / 12) * 360 + (minute / 60) * 30 + 90 // 90度ずらす

    if (this.$minuteHand) {
      this.$minuteHand.style.transform = `rotate(${minuteDeg}deg)`
    }

    if (this.$hourHand) {
      this.$hourHand.style.transform = `rotate(${hourDeg}deg)`
    }
  }

  _toggleColon(second) {
    if (!this.$target) return

    const colons = this.$target.querySelectorAll('.colon')
    if (!colons.length) return

    // 偶数秒で表示、奇数秒で非表示
    const isVisible = second % 2 === 0
    colons.forEach((colon) => {
      colon.style.opacity = isVisible ? '1' : '0'
    })
  }
}